import { getJSON } from 'bv-fetch';
import { locale } from 'bv-i18n';
import { loggedIn } from 'bv-helpers/session';

const fetchSections = () => getJSON(`/api/site_navigation/top_navigation?l=${loggedIn()}&c=${locale()}`);

export default fetchSections;
